var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessingPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 139.685,
    height: 149.131,
    viewBox: "0 0 139.685 149.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_40517",
    x: 0,
    y: 0,
    width: 125.592,
    height: 142.796,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Processing_payment_icon",
    "data-name": "Processing payment icon",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_40517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40517-2",
    "data-name": "Path 40517",
    d: "M13.659,112.019l13.209,12.552,13.591-12.923L54.285,124.8l13.5-12.834,13.437,12.77,14.337-13.637,12.031,12.081V7.508A7.51,7.51,0,0,0,100.085,0H7.508A7.51,7.51,0,0,0,0,7.508V124.2Z",
    transform: "translate(9 6)",
    fill: "#f2f3f3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40518",
    "data-name": "Path 40518",
    d: "M64.656,13.416H8.322a3.906,3.906,0,1,1,0-7.811H64.656a3.906,3.906,0,0,1,0,7.811",
    transform: "translate(11.341 14.405)",
    fill: "#d8d9db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40519",
    "data-name": "Path 40519",
    d: "M64.656,20.279H8.322a3.906,3.906,0,1,1,0-7.811H64.656a3.906,3.906,0,0,1,0,7.811",
    transform: "translate(11.341 32.043)",
    fill: "#d8d9db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40520",
    "data-name": "Path 40520",
    d: "M47.813,27.142H8.322a3.906,3.906,0,1,1,0-7.811H47.813a3.906,3.906,0,0,1,0,7.811",
    transform: "translate(11.341 49.68)",
    fill: "#d8d9db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40521",
    "data-name": "Path 40521",
    d: "M91.891,38.5h0l-.057-.775L86.526,36.6,85.7,34.151l3.531-4.059-.364-.635a19.3,19.3,0,0,0-4.944-5.669l-.578-.45-4.5,2.938L76.53,25.119l-.378-5.4-.746-.164a24.742,24.742,0,0,0-7.411-.514l-.764.061-1.121,5.3-2.449.825-4.077-3.545-.646.4a23.32,23.32,0,0,0-5.616,4.887l-.486.582,2.949,4.534L54.632,34.4l-5.341.371-.207.675A16.715,16.715,0,0,0,48.573,43l.114.7,5.234,1.1.825,2.449-.764.878-.321-.193a28.8,28.8,0,0,0-8.018-3.324l-.743-.182L41.687,49.9H38.431L35.222,44.44l-.739.179a27.206,27.206,0,0,0-8.036,3.327l-.65.4,1.592,6.126-2.3,2.3-6.076-1.578-.414.578a19.424,19.424,0,0,0-3.377,8.168l-.114.7,5.409,3.181v3.245l-5.451,3.209.164.735a26.255,26.255,0,0,0,3.334,8.047l.4.639,6.123-1.585,2.3,2.3-1.578,6.08.589.414a20.727,20.727,0,0,0,8.14,3.374l.707.129,3.184-5.423h3.249L44.868,94.4l.707-.132a21.144,21.144,0,0,0,8.132-3.37l.593-.414L52.722,84.4l2.3-2.3,6.14,1.592.393-.668a30.772,30.772,0,0,0,3.32-8l.2-.75-5.473-3.217V67.809l5.434-3.192-.143-.718a22.3,22.3,0,0,0-.578-2.26l.668.193a17.766,17.766,0,0,0,3.456.646c.5.046,1.01.064,1.514.064a17.63,17.63,0,0,0,2.567-.186l.71-.1,1.107-5.248,2.449-.825,4.052,3.524.632-.35A18.11,18.11,0,0,0,87.151,54.4l.432-.575-2.927-4.495,1.157-2.306,5.4-.382.168-.757a26.443,26.443,0,0,0,.525-3.816,27.078,27.078,0,0,0-.014-3.57M40.055,79.04h0a9.605,9.605,0,1,1,9.607-9.607,9.6,9.6,0,0,1-9.607,9.607M55.017,56.767l-2.3-2.3.164-.625c.264.343.528.693.81,1.025a22.841,22.841,0,0,0,1.739,1.789Zm8.689,3.174a22.66,22.66,0,0,0-2.185-4.148l-.282-.425.357-.232,2.31,1.153.368,5.269q-.252-.825-.568-1.617M80.26,40.392a9.925,9.925,0,1,1-9.925-9.925h0A9.932,9.932,0,0,1,80.26,40.392Z",
    transform: "translate(38.727 48.729)",
    fill: "#5a5b5e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingPaymentIcon);
export default __webpack_public_path__ + "static/media/ProcessingPaymentIcon.1af104f6aabfde258ede39e20c9e313b.svg";
export { ForwardRef as ReactComponent };